import styled from 'styled-components/macro'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  > * {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
`
